import { usePostDisputeMutation } from '@p2p/services';
import { MSP_PAGE } from '@p2p/shared/constants';
import { getFirstErrorMessage } from '@p2p/shared/functions';
import { useMemo } from 'react';
import { ErrorResponse, useNavigate, useParams } from 'react-router-dom';

import { TransferIssues } from './TransferIssues';
import { generateComment } from './TransferIssues.helpers';
import { FileProps, FormHelper, FormValues } from './TransferIssues.types';

type MatchingPageDisputeProps = {
  comeback: () => void;
  // P2P-2880: куда вести после создания диспута. Не задано — страница msp_page (как раньше).
  successPath?: string;
};

export const MatchingPageDispute = ({ comeback, successPath }: MatchingPageDisputeProps) => {
  const [createDispute, { isLoading: isCreatingDispute }] = usePostDisputeMutation();
  const { id = '' } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const onSubmit = (data: FormValues, formHelper: FormHelper) => {
    const { selectedIssue, comment, files } = data;
    const { setValue, setError } = formHelper;
    const formData = new FormData();

    formData.append('order_withdrawal_id', id);
    formData.append('user_type', 'user');
    formData.append('comment', generateComment(selectedIssue, comment));
    files.map((file) => formData.append('files', file));

    createDispute(formData)
      .unwrap()
      .then(() => {
        navigate(successPath ?? `${MSP_PAGE}/${id}/dispute/success`);
      })
      .catch((e: ErrorResponse) => {
        const errorMessage = e?.data?.order_withdrawal_id?.[0] || e?.data?.[0];
        const _files = e?.data?.files;
        if (_files) {
          const indexesRemoves = Object.keys(_files).map((i) => +i);
          setValue(
            'files',
            files.filter((_, index) => !indexesRemoves.includes(index)),
          );
          const message = Object.values(_files)?.[0] as string;
          if (message) {
            setError('files', { message });
            return;
          }
        }

        const firstErrorMessage = getFirstErrorMessage(e.data);
        if (errorMessage || firstErrorMessage) {
          setError('files', { message: errorMessage || firstErrorMessage });
        }
      });
  };

  const fileProps: FileProps = useMemo(
    () => ({
      maxCountFiles: 1,
      allowedFormats: ['pdf'],
      maxFileSize: 2,
      title: 'Загрузите PDF-файл',
    }),
    [],
  );

  return (
    <TransferIssues
      id={id}
      comeback={comeback}
      onSubmit={onSubmit}
      isLoading={isCreatingDispute}
      fileProps={fileProps}
    />
  );
};
